import { User } from './users'

export interface Group {
    name: string;
    cname?: string;
    id?: string;
    dnsVerified?: boolean;
    sslActive?: boolean;
    uid?: User;
}


export abstract class GroupData {
    abstract getGroups();
    abstract createGroup(Group: Group);
    abstract deleteGroup(id: string);
    abstract verifyDNS(id: string);
    abstract sslCname(id: string);
    abstract editGroup(Group: Group, id: string)
}
